import { EqMagModal } from './EqMagModal';

export const EqMfaMagModal = EqMagModal({
  title: 'Mfa Magnitude',
  desc: 'The Mfa magnitudes are computed from the felt area, for earthquakes that occurred before seismic instruments were in general use.',
});
